import React from 'react'
import { ArrowLeft } from 'iconsax-react'
import { useTheme } from '@mui/material'
import { useAppDispatch } from '../../../../hooks/redux'

import EngagementHubV2 from '../../../../components/organisms/EngagementHubV2'

import { useQueueState } from '../../../../providers/QueueStateProvider'
import { MobileScreen, setMobileScreen } from '../../../../slices/convo'
import useStyles from './styles'

interface MobileEngagementHubProps {
  openMergeModal: () => void
}

const MobileEngagementHub: React.FC<MobileEngagementHubProps> = ({
  openMergeModal
}) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()

  const { id: selectedConversation } = useQueueState()

  const handleReturnClick = React.useCallback(
    e => {
      dispatch(setMobileScreen(MobileScreen.Conversation))
    },
    [dispatch]
  )

  if (!selectedConversation) {
    dispatch(setMobileScreen(MobileScreen.Queue))
  }

  const classes = useStyles()

  return (
    <React.Fragment>
      <div className={classes.root}>
        <ArrowLeft
          size={theme.size.xl}
          onClick={handleReturnClick}
          className={classes.action}
        />
        <div className={classes.header}>User Details</div>
      </div>
      <EngagementHubV2 openMergeModal={openMergeModal} />
    </React.Fragment>
  )
}

export default MobileEngagementHub
